export const selectors = {
  getIsLogged: (state) => state.UserReducers.logged,
};
